import * as Dialog from '@radix-ui/react-dialog'
import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import StripePayment from '../payment-methods/stripe-payment/StripePayment'
import styles from './PaymentModal.module.scss'
import type { PaymentMethodData, PortalContainer } from '../../types'

interface PaymentModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  paymentMethod: PaymentMethodData['paymentMethod'] | undefined
  portalContainer?: PortalContainer
}

const renderPaymentComponent = (
  paymentMethod: PaymentMethodData['paymentMethod'] | null,
  onClose: () => void,
  isOpen: boolean,
) => {
  switch (paymentMethod) {
    case 'stripe':
      return <StripePayment onCancel={onClose} isOpen={isOpen} />
    default:
      return <div>No payment method selected</div>
  }
}

export const PaymentModal = ({
  open,
  onOpenChange,
  paymentMethod,
  portalContainer,
}: PaymentModalProps) => {
  const { t } = useTranslation()
  const titleId = `${useId().replace(/:/g, '')}-payment-modal-title`
  if (!paymentMethod) return null

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal container={portalContainer ?? undefined}>
        <Dialog.Overlay className={styles.overlay} />
        <Dialog.Content
          className={styles.content}
          aria-labelledby={titleId}
          aria-describedby={undefined}
          onPointerDownOutside={(e) => {
            const target = e.target as HTMLElement
            if (target?.closest?.('[data-stripe-payment-trap="true"]')) e.preventDefault()
          }}
          onInteractOutside={(e) => {
            const target = e.target as HTMLElement
            if (target?.closest?.('[data-stripe-payment-trap="true"]')) e.preventDefault()
          }}
        >
          <Dialog.Title id={titleId} className={styles.title}>
            {t('completeOrder.completePayment')}
          </Dialog.Title>

          {renderPaymentComponent(paymentMethod, () => onOpenChange(false), open)}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
